import React, { Component } from 'react';

import './../PersonRegist.css'

import Api from '../../../api/wxapi';
import intl from 'react-intl-universal';
import Select from 'react-select';



//设备信息
export default class devicebuy extends Component {
    constructor(props) {
        super();
        this.state = {
            username:'',
            mobile:'',
            name:'',
            select: [],
            arr:[{ name: '手持式轮胎花纹深度智能检测仪', value: 'handheld' ,selected:false}, { name: '通过式轮胎花纹深度智能检测仪', value: 'passthrough',selected:false }]
        };

    }

    componentDidMount() {
        document.title = '设备尝鲜'

    }
    render() {
        let {

            username,
            mobile,
            name,
            select,
            arr,
        } = this.state
    

       let _self=this
        return (
            <div className='flex-column-container' style={{ paddingLeft: 12, paddingRight: 12, flex: 1, }}>
                <div className='itemContaier'>
                    <p className='itemname'>{'公司名字'}</p>
                    <input className="inputbox" type="text" value={name} onChange={event => this.setState({ name: event.target.value })} placeholder={'请输入公司名字'} />
                </div>



                <div className='itemContaier'>
                    <p className='itemname'>{'联系人姓名'}</p>
                    <input className="inputbox" type="text" value={username} onChange={event => this.setState({ username: event.target.value })} placeholder={'请输入联系人姓名'} />
                </div>

                <div className='itemContaier'>
                    <p className='itemname'>{intl.get('txt_shoujhm')}</p>
                    <input className="inputbox" type="text" value={mobile} onChange={event => this.setState({ mobile: event.target.value })} placeholder={'请输入手机号码'} />
                </div>


                <div className='itemContaier'>
                    <p className='itemname'>{'请选择要了解的设备'}</p>
                    {arr.map((item,index)=>{
                    
                    return(<div  className= {item.selected?'select11':'unselect'}  key={item.value} onClick={_self.clickselect.bind(_self,item)}> {item.name}</div>)
 

                    })}  
                </div>

                <button className="pr-button" onClick={this.submit}>{'提交'}</button>

            </div>
        )
    }


    clickselect(item){
 
    
     item.selected=!item.selected
      this.setState({arr:this.state.arr})
  
    }

    submit=()=>{
        let str=''
        let {

            username,
            mobile,
            name,
            select,
            arr,
        } = this.state  

       arr.map((item,index)=>{
          if(item.selected){
              if(str.length<=0){
                  str=str+item.value
              }else {
                  str=str+','+item.value
              }   
          } 
       }) 

       if(username&&name&&mobile&&arr){
           let param={company:name,mobile:mobile,contact:name,device_type:str}
        Api.buydevice(param).then(res=>{
            console.log(res)
            if (res.data.code == 0) {
              this.props.history.push(`/person/ShowResult?flag=true&type=${global.constants.Suggestion}`)
            } else {
              alert(res.data.message)
            }
   
          })  
       }else{

       }
            
        

    }

 

}



// WEBPACK FOOTER //
// ./src/views/person/reward/devicebuy.js